import format from 'sugar/number/format';
import round from 'sugar/number/round';
import capitalize from 'sugar/string/capitalize';
import moment from 'moment';

const UtilsService = {
    format: (number) => {
        return format(number);
    },
    round: (number, precision = 2) => {
        return round(number, precision);
    },
    formatPlayerName: (firstName, lastName) => {
        return `${capitalize(firstName, true)} ${lastName[0].toUpperCase()}.`;
    },
    capitalize: (firstName, lastName = '') => {
        return `${capitalize(firstName, true)} ${capitalize(lastName, true)}`;
    },
    formatDate: (date, format = 'DD/MM/YY') => {
        return moment(date).format(format);
    },
}

export default UtilsService;